import * as React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import { Box } from "@mui/material";

// استيراد الشريط العلوي
import TopBar from "./utils/TopBar"; 
import StudentsList from "./pages/StudentsList";
// 1. استيراد صفحة التقييمات الجديدة
import StudentAssessments from "./pages/StudentAssessments"; 

export default function App() {
  const location = useLocation(); // لمعرفة المسار الحالي

  // نعتمد فقط على حالة تسجيل الدخول المحفوظة مسبقاً
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );

  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  // التحكم في إظهار الشريط العلوي (نخفيه في صفحة الدخول وصفحة الـ splash)
  const showTopBar = isAuthenticated && location.pathname !== "/login" && location.pathname !== "/splash";

  return (
    // هذه الحاوية ضرورية جداً لكي يأخذ التطبيق بالكامل لون الخلفية (فاتح/داكن)
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundColor: 'background.default', // يتغير تلقائياً مع الثيم
      color: 'text.primary',
      transition: 'background-color 0.3s ease' // انتقال ناعم عند تبديل الثيم
    }}>
      
      {/* عرض الشريط العلوي فقط للمستخدم المسجل وفي غير صفحة الدخول */}
      {showTopBar && <TopBar />}

      {/* حاوية محتوى الصفحات */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <Routes>
          <Route
            path="/login"
            element={<LoginPage setIsAuthenticated={setIsAuthenticated} />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="students"
            element={
              <ProtectedRoute>
                <StudentsList />
              </ProtectedRoute>
            }
          />
          
          {/* 2. إضافة المسار الجديد لصفحة تقييمات الطالب */}
          <Route
            path="/student/:studentId/assessments"
            element={
              <ProtectedRoute>
                <StudentAssessments />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
    </Box>
  );
}